import { Stack } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { FacebookIcon } from '@/components/content/Footer/parts/FacebookIcon';
import { InstagramIcon } from '@/components/content/Footer/parts/InstagramIcon';
import { TikTokIcon } from '@/components/content/Footer/parts/TikTokIcon';

const socialIcons = {
	facebook: <FacebookIcon />,
	instagram: <InstagramIcon />,
    tiktok: <TikTokIcon />,
};

const socialLinks = [
    { name: 'facebook', url: 'https://www.facebook.com/dportenis' },
    { name: 'instagram', url: 'https://www.instagram.com/dportenis' },
    { name: 'tiktok', url: 'https://www.tiktok.com/@dportenisoficial' },
] as const;


export const SocialLinks = () => (
    <Stack direction="row">
        {socialLinks.map(({ name, url }) => (
            <Linkable type="button-icon" href={url} key={url} aria-label={name} target="_blank">
                {socialIcons[name]}
            </Linkable>
        ))}
    </Stack>
);
